<template>
  <modal name="rotinaInfo" height="auto" width="1024" :scrollable="true" :clickToClose="true">
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <CTabs variant="tabs" class="nav-tabs-boxed">
          <CTab title="Última execução">
            <UltimaRotina :rotina="rotina" />
          </CTab>
          <CTab title="Histórico de execuções">
            <LogUltimasRotinas :rotina="rotina" />
          </CTab>
        </CTabs>
      </div>
    </div>
    <div class="modal-footer">
      <button class="button" v-on:click="close">Fechar</button>
      <button class="button button-success" v-on:click="syncRotina(rotina)">Executar</button>
      <button class="button button-primary" v-on:click="loadRotinas">Atualizar</button>
    </div>
  </modal>
</template>
<script>
import CloseModal from "../../components/CloseModal";
import UltimaRotina from './RotinaInfo/UltimaRotina';
import LogUltimasRotinas from './RotinaInfo/LogUltimasRotinas';

export default {
  name: "rotinaInfo",
  props: [
    "close",
    "rotina",
    "descricao",
    "loadRotinas",
    "syncRotina"
  ],
  components: {
    CloseModal,
    UltimaRotina,
    LogUltimasRotinas
  }
};
</script>
